/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_nav_basic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage Calculator`)
};

const es_pct_nav_basic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Porcentaje`)
};

const de_pct_nav_basic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozentrechner`)
};

const nl_pct_nav_basic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentagecalculator`)
};

const fr_pct_nav_basic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de pourcentage`)
};

const it_pct_nav_basic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di percentuali`)
};

const pt_br2_pct_nav_basic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Porcentagem`)
};

const pt_pct_nav_basic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Percentagens`)
};

const ja_pct_nav_basic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント計算機`)
};

const zh_pct_nav_basic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_nav_basic = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_nav_basic(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_nav_basic", locale)
	if (locale === "en") return en_pct_nav_basic(inputs)
	if (locale === "es") return es_pct_nav_basic(inputs)
	if (locale === "de") return de_pct_nav_basic(inputs)
	if (locale === "nl") return nl_pct_nav_basic(inputs)
	if (locale === "fr") return fr_pct_nav_basic(inputs)
	if (locale === "it") return it_pct_nav_basic(inputs)
	if (locale === "pt-BR") return pt_br2_pct_nav_basic(inputs)
	if (locale === "pt") return pt_pct_nav_basic(inputs)
	if (locale === "ja") return ja_pct_nav_basic(inputs)
	return zh_pct_nav_basic(inputs)
};